<template>
  <EquipmentRow data-cy="shroud-row-equipment-row">
    <template #left></template>

    <template #default="{ toggle }">
      <AddRemoveButtons
        :hide-add-below="true"
        :disable-remove="!selectedShroudId"
        data-cy="shroud-row-add-remove-buttons"
        @remove="handleShroudRemove"
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            :rule-names="[
              'shroud_size_top_casing',
              'shroud_size_bottom_casing',
              'intake_size_shroud',
              'seal_size_shroud',
              'pump_size_shroud',
              'motor_size_shroud'
            ]"
            data-cy="shroud-row-equipment-panel"
            @toggle="toggle"
          >
            <template #header>Shroud</template>
            <template v-if="selectedShroud" #trigger>
              {{ computeCasingLabel(selectedShroud) }}
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }">
      <div class="col-12 text-center">
        <CasingSearchView
          :is-admin="false"
          :include-types="[Casings_Type_Enum.Shroud, Casings_Type_Enum.Both]"
          :data-cy="`shroud-search-view-${selectedShroudId}`"
          @select="handleShroudSelect($event, toggle)"
        />
      </div>
    </template>
  </EquipmentRow>
</template>

<script setup lang="ts">
// import ConverterInput from "@/components/ConverterInput.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import CasingSearchView from "../casings/CasingSearchView.vue";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import { injectStrict } from "@/utils/utils";
import { computed, provide } from "vue";
import { equipmentFormKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { computeCasingLabel } from "@/models/equipment/casings/properties";
import { Casings_Type_Enum, type Casings } from "gql/api";
import type { StackLocation } from "../d";

// TODO: not sure if we need this here or not
// import {} from
// getShroudFieldName,
// getShroudFieldValue
// "@/composables/forms/stackAwareFields";

const props = defineProps<{
  stack?: StackLocation;
}>();

const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

// Stack-aware shroud selection
const selectedShroud = computed(() => {
  if (props.stack === "lower") {
    return equipment.value?.r_lower_shroud;
  }
  return equipment.value?.r_shroud;
});

const selectedShroudId = computed(() => {
  if (props.stack === "lower") {
    return equipment.value.lower_shroud_id;
  }
  return equipment.value.shroud_id;
});

function handleShroudSelect(shroud: Casings, toggle: () => void) {
  toggle();
  if (props.stack === "lower") {
    equipmentForm.update({
      r_lower_shroud: shroud,
      lower_shroud_id: shroud?.id
    } as Partial<typeof equipmentForm.data.value>);
  } else {
    equipmentForm.update({
      r_shroud: shroud,
      shroud_id: shroud?.id
    });
  }
}

function handleShroudRemove() {
  if (props.stack === "lower") {
    equipmentForm.update({
      r_lower_shroud: null,
      lower_shroud_id: null
    } as Partial<typeof equipmentForm.data.value>);
  } else {
    equipmentForm.update({
      r_shroud: null,
      shroud_id: null
    });
  }
}

provide("equipment", undefined);
provide(
  "selected-equipment-id",
  computed(() => selectedShroudId.value)
);
</script>
